export default "__VITE_ASSET__BWxw_dF6__"